// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-field-body {
  border-style: none;
  margin: 10px 0;
}

.table-container {
  overflow: auto;
  background-color: #fff;
  margin: 10px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
  font-size: 0.9rem;
  table-layout: fixed;
}

.data-table thead th {
  background-color: #f8f9fa;
  font-weight: 600;
  border-bottom: 2px solid rgba(0, 0, 0, 0.12);
  position: sticky;
  top: 0;
  z-index: 1;
  text-align: center;
  vertical-align: bottom;
  padding: 8px 4px;
}

.data-table td {
  padding: 0px;
  border-radius: 4px;
  vertical-align: top;
}

.data-table th:not(:first-child),
.data-table td:not(:first-child) {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.data-table th:first-child,
.data-table td:first-child {
  border: none;
}

.data-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.data-table tbody tr:hover {
  background-color: #f0f8ff;
}

:host ::ng-deep .table-cell {
  position: relative;
  min-width: 200px;
  max-width: 300px;
  width: auto;
  overflow: hidden;
  box-sizing: border-box;
  vertical-align: top;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
:host ::ng-deep .table-cell .field-header {
  min-height: 34px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  text-align: center;
}
:host ::ng-deep .table-cell app-textbox .c-validation,
:host ::ng-deep .table-cell app-currency .c-validation,
:host ::ng-deep .table-cell app-number .c-validation,
:host ::ng-deep .table-cell app-phone-number .c-validation,
:host ::ng-deep .table-cell app-email .c-validation,
:host ::ng-deep .table-cell app-website .c-validation,
:host ::ng-deep .table-cell app-dropdown .c-validation {
  margin-top: 0px !important;
}
:host ::ng-deep .table-cell app-textbox input,
:host ::ng-deep .table-cell app-textbox textarea,
:host ::ng-deep .table-cell app-currency input,
:host ::ng-deep .table-cell app-number input,
:host ::ng-deep .table-cell app-phone-number input,
:host ::ng-deep .table-cell app-email input,
:host ::ng-deep .table-cell app-website input,
:host ::ng-deep .table-cell app-dropdown select {
  margin: 0px 3px 0px 3px !important;
}
:host ::ng-deep .table-cell app-date {
  width: 100% !important;
  display: block;
  box-sizing: border-box;
}
:host ::ng-deep .table-cell app-date .inline {
  width: 100% !important;
  height: 35px !important;
  max-height: 35px !important;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: 3px !important;
  margin-right: 3px !important;
}
:host ::ng-deep .table-cell app-date .div-one {
  margin-top: 12px !important;
  margin-bottom: 5px !important;
  width: calc(100% - 40px) !important;
  flex: 1;
  box-sizing: border-box;
}
:host ::ng-deep .table-cell app-date .div-one .second-date {
  display: block !important;
  visibility: hidden !important;
  position: absolute !important;
}
:host ::ng-deep .table-cell app-date .div-one .input-date,
:host ::ng-deep .table-cell app-date .div-one .input-time,
:host ::ng-deep .table-cell app-date .div-one .input-dateTime {
  width: 100% !important;
  max-width: none !important;
  padding: 5px 10px;
  margin: 0 !important;
  box-sizing: border-box;
}
:host ::ng-deep .table-cell app-date .div-two {
  width: 40px !important;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px !important;
}
:host ::ng-deep .table-cell app-date .txt-field-body {
  overflow: hidden !important;
  width: 100%;
}
:host ::ng-deep .table-cell app-date .c-validation {
  margin-top: 0px !important;
}

.c-validation {
  font-weight: normal;
  font-size: 0.8125em;
  line-height: 1.3em;
  margin-top: 5px;
  margin-left: 12px;
  margin-right: 10px;
  color: #dc3545;
}

.empty-table {
  padding: 40px 20px;
  text-align: center;
}

.text-danger {
  color: #dc3545 !important;
}

.text-muted {
  color: #6c757d !important;
}

.delete-cell {
  width: 5%;
  text-align: center;
  padding: 8px;
  border-left: none !important;
  border-bottom: none !important;
  border-top: none !important;
}

.btn-delete {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.btn-delete:disabled {
  color: #ccc;
  cursor: not-allowed;
  transform: none;
}

.btn-delete:disabled:hover {
  background: none;
  color: #ccc;
}

.btn-add-row {
  cursor: pointer;
}

.table-actions {
  text-align: left;
}

.new-field {
  font-size: 25px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column-reverse;
  border-width: 1px;
  border-style: dashed;
  border-radius: 0.5em;
  height: 35px;
}

.new-field .field .new-table {
  border-radius: unset !important;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-type/table/table.component.scss"],"names":[],"mappings":"AAAA;EACG,kBAAA;EACA,cAAA;AACH;;AAEA;EACG,cAAA;EACA,sBAAA;EACA,YAAA;AACH;;AAEA;EACG,WAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;AACH;;AAEA;EACG,yBAAA;EACA,gBAAA;EACA,4CAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AACH;;AAEA;EACG,YAAA;EACA,kBAAA;EACA,mBAAA;AACH;;AAEA;;EAEG,qCAAA;AACH;;AAEA;;EAEG,YAAA;AACH;;AAEA;EACG,yBAAA;AACH;;AAEA;EACG,yBAAA;AACH;;AAGG;EACG,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AAAN;AAEM;EACG,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;AAAT;AAUS;;;;;;;EACG,0BAAA;AAFZ;AAMM;;;;;;;;EAQG,kCAAA;AAJT;AAOM;EACG,sBAAA;EACA,cAAA;EACA,sBAAA;AALT;AAOS;EACG,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AALZ;AAQS;EACG,2BAAA;EACA,6BAAA;EACA,mCAAA;EACA,OAAA;EACA,sBAAA;AANZ;AAQY;EACG,yBAAA;EACA,6BAAA;EACA,6BAAA;AANf;AASY;;;EAGG,sBAAA;EACA,0BAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AAPf;AAWS;EACG,sBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;AATZ;AAYS;EACG,2BAAA;EACA,WAAA;AAVZ;AAaS;EACG,0BAAA;AAXZ;;AAiBA;EACG,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAdH;;AAiBA;EACG,kBAAA;EACA,kBAAA;AAdH;;AAiBA;EACG,yBAAA;AAdH;;AAiBA;EACG,yBAAA;AAdH;;AAiBA;EACG,SAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;AAdH;;AAiBA;EACG,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAdH;;AAiBA;EACG,WAAA;EACA,mBAAA;EACA,eAAA;AAdH;;AAiBA;EACG,gBAAA;EACA,WAAA;AAdH;;AAiBA;EACG,eAAA;AAdH;;AAiBA;EACG,gBAAA;AAdH;;AAiBA;EACG,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,YAAA;AAdH;;AAiBA;EACG,+BAAA;AAdH","sourcesContent":[".table-field-body {\n   border-style: none;\n   margin: 10px 0;\n}\n\n.table-container {\n   overflow: auto;\n   background-color: #fff;\n   margin: 10px;\n}\n\n.data-table {\n   width: 100%;\n   border-collapse: collapse;\n   margin: 0;\n   font-size: 0.9rem;\n   table-layout: fixed; \n}\n\n.data-table thead th {\n   background-color: #f8f9fa;\n   font-weight: 600;\n   border-bottom: 2px solid rgba(0, 0, 0, 0.12);\n   position: sticky;\n   top: 0;\n   z-index: 1;\n   text-align: center;\n   vertical-align: bottom; \n   padding: 8px 4px;\n}\n\n.data-table td {\n   padding: 0px;\n   border-radius: 4px;\n   vertical-align: top;\n}\n\n.data-table th:not(:first-child),\n.data-table td:not(:first-child) {\n   border: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.data-table th:first-child,\n.data-table td:first-child {\n   border: none;\n}\n\n.data-table tbody tr:nth-child(even) {\n   background-color: #f9f9f9;\n}\n\n.data-table tbody tr:hover {\n   background-color: #f0f8ff;\n}\n\n:host ::ng-deep {\n   .table-cell {\n      position: relative;\n      min-width: 200px;\n      max-width: 300px;\n      width: auto;\n      overflow: hidden;\n      box-sizing: border-box;\n      vertical-align: top;\n      word-wrap: break-word;\n      overflow-wrap: break-word;\n\n      .field-header {\n         min-height: 34px;\n         display: flex;\n         align-items: flex-end;\n         justify-content: center;\n         text-align: center;\n      }\n\n      app-textbox,\n      app-currency,\n      app-number,\n      app-phone-number,\n      app-email,\n      app-website,\n      app-dropdown {\n         .c-validation {\n            margin-top: 0px !important;\n         }\n      }\n\n      app-textbox input,\n      app-textbox textarea,\n      app-currency input,\n      app-number input,\n      app-phone-number input,\n      app-email input,\n      app-website input,\n      app-dropdown select {\n         margin: 0px 3px 0px 3px !important;\n      }\n\n      app-date {\n         width: 100% !important;\n         display: block;\n         box-sizing: border-box;\n\n         .inline {\n            width: 100% !important;\n            height: 35px !important;\n            max-height: 35px !important;\n            display: flex;\n            align-items: center;\n            box-sizing: border-box;\n            margin-left: 3px !important;\n            margin-right: 3px !important;\n         }\n\n         .div-one {\n            margin-top: 12px !important;\n            margin-bottom: 5px !important;\n            width: calc(100% - 40px) !important;\n            flex: 1;\n            box-sizing: border-box;\n\n            .second-date {\n               display: block !important;\n               visibility: hidden !important;\n               position: absolute !important;\n            }\n\n            .input-date,\n            .input-time,\n            .input-dateTime {\n               width: 100% !important;\n               max-width: none !important;\n               padding: 5px 10px;\n               margin: 0 !important;\n               box-sizing: border-box;\n            }\n         }\n\n         .div-two {\n            width: 40px !important;\n            flex-shrink: 0;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            margin-bottom: 5px !important;\n         }\n\n         .txt-field-body {\n            overflow: hidden !important;\n            width: 100%;\n         }\n\n         .c-validation {\n            margin-top: 0px !important;\n         }\n      }\n   }\n}\n\n.c-validation {\n   font-weight: normal;\n   font-size: 0.8125em;\n   line-height: 1.3em;\n   margin-top: 5px;\n   margin-left: 12px;\n   margin-right: 10px;\n   color: #dc3545;\n}\n\n.empty-table {\n   padding: 40px 20px;\n   text-align: center;\n}\n\n.text-danger {\n   color: #dc3545 !important;\n}\n\n.text-muted {\n   color: #6c757d !important;\n}\n\n.delete-cell {\n   width: 5%;\n   text-align: center;\n   padding: 8px;\n   border-left: none !important;\n   border-bottom: none !important;\n   border-top: none !important;\n}\n\n.btn-delete {\n   background: none;\n   border: none;\n   font-size: 20px;\n   cursor: pointer;\n   padding: 4px;\n   border-radius: 50%;\n   transition: all 0.2s ease;\n}\n\n.btn-delete:disabled {\n   color: #ccc;\n   cursor: not-allowed;\n   transform: none;\n}\n\n.btn-delete:disabled:hover {\n   background: none;\n   color: #ccc;\n}\n\n.btn-add-row {\n   cursor: pointer;\n}\n\n.table-actions {\n   text-align: left;\n}\n\n.new-field {\n   font-size: 25px;\n   text-align: center;\n   display: flex;\n   justify-content: center;\n   flex-direction: column-reverse;\n   border-width: 1px;\n   border-style: dashed;\n   border-radius: 0.5em;\n   height: 35px;\n}\n\n.new-field .field .new-table {\n   border-radius: unset !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
